import { Stack } from '@mui/material'
import React from 'react'

import { UStackProps } from './type'

// NOTE: spacing props add 4px margin for every 1 increase.
// https://mui.com/material-ui/react-stack/

export const UStack = ({ children, ...props }: UStackProps) => {
  return <Stack {...props}>{children}</Stack>
}
